import * as React from 'react';
import { useEffect, useReducer } from 'react';

import { Modal, FormGroup, Label, Input, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { ShoppingCart } from '../../models/ShoppingCart';

type State = {
    name: string;
}

const initialState: State = {
    name: ""
}

function EditCartModal(props: {
    open: boolean,
    cart: ShoppingCart,
    onCancel: () => void,
    onSave: (name: string, cartId: string) => void
}) {

    let [state, setState] = useReducer(
        (prevState: State, newState: Partial<State>) => ({ ...prevState, ...newState }),
        initialState
    );

    useEffect(() => {
        if (props.cart) {
            setState({ name: props.cart.CartName });
        }
    }, [props.cart])

    const cancel = () => {
        setState({ name: '' });
        props.onCancel();
    }

    return <>
        <Modal backdrop={'static'} isOpen={props.open} toggle={props.onCancel} size="md" className="modal-dialog-centered">
            <ModalHeader className="modal-header">
                <h5 className="modal-title">Edit Cart Name</h5>
                <button type="button" className="close" aria-label="Close" onClick={cancel}><span aria-hidden="true"><i className="fa fa-times"></i></span></button>
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Name</Label>
                    <Input style={{ height: "40px", paddingLeft: "7px" }} value={state.name} onChange={(e) => setState({ name: e.target.value })}></Input>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <div className="w-100 d-flex">
                    <Button color="white" className="mr-2 flex-fill" onClick={cancel}>Cancel</Button>
                    <Button color="white" className="btn btn-black d-inline-block border flex-fill"
                        onClick={() => props.onSave(state.name, props.cart.CartId)}
                        disabled={!state.name || state.name.length === 0}>Save</Button>
                </div>
            </ModalFooter>
        </Modal>
    </>

}

export default EditCartModal;
